/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $PlayerRatingV2 = {
    properties: {
        playerId: {
            type: 'number',
            isRequired: true,
        },
        value: {
            type: 'number',
            isRequired: true,
        },
        justification: {
            type: 'Translation',
            isRequired: true,
        },
    },
} as const;
